export const GETPRODUCTS = "GETPRODUCTS";
